import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { reviewPartnerConfiguration } from '../../partner-content/Review-partner-content/Interface/review-partner.i';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';
import { OemConstants } from '../../../../app/core/routing/services/oem/constants/oem.constants';
import { PartnersService } from '../../../core/routing/services/Partners_api/partners.service';
import { Partners } from '../Partners/Interface/partner.i';
import { Content } from '../../oem-portal/interface/oem-portal-interface.i';
import { PartnerContentStore } from '../store/partner-content-store';
@Component({
  selector: 'iposcen-review-partner-content',
  templateUrl: './review-partner-content.component.html',
  styleUrls: ['./review-partner-content.component.scss']
})
export class ReviewPartnerContentComponent implements OnInit {
  @Output() readonly sendPartner = new EventEmitter();
  @Output() readonly viewOn = new EventEmitter();
  @Output() readonly contentID = new EventEmitter();
  @Output() readonly autoID = new EventEmitter();
  @Output() readonly reviewOn = new EventEmitter();
  @Output() readonly sendPartnerData = new EventEmitter();
  @Input() selectedPartnerName: string;
  @Input() checkReviewStatus: boolean;
  @Input() contentsInfo: any;
  isNoneSelected = true;
  isReviewOpen = false;
  partner: Partners[];
  partnerData: any;
  getPartnerDetails: any = {};
  isViewOpen: boolean;
  spinnerStatus = true;
  maxSize = 5;
  allPartnerData: reviewPartnerConfiguration[] = [];
  globalSortBy: string;
  globalSortValue: string;
  page: number;
  pID: any;
  contents: Content[];
  showFrom: number;
  showTo: number;
  paginationCount: number;
  tableSize: number;
  noData: boolean;
  partnerLabel: string;
  partnerID: any;
  selectedButton: string;
  isPartnerEmpty: boolean;
  // Attractor loop variables 
  isPartnerTabActive = true;
  displayAttr = [];
  sortType = OemConstants.ASCENDING_ORDER;
  oemConst = OemConstants;
  type = OemConstants.UPDATED_TIME;
  AttrPageCount = 0;
  attrShowTo = 10
  attShowFrom = 1;
  @Output() readonly attrViewOpen = new EventEmitter();
  @Output() readonly attrID = new EventEmitter();
  @Output() readonly adminRef = new EventEmitter();
  @Output() readonly pid = new EventEmitter();
  @Output() readonly enableComments = new EventEmitter();
  private ngUnsubscribe = new Subject<boolean>();
  pageAttr: number;
  constructor(private partnersService: PartnersService,
    private oemService: OemService, private store: PartnerContentStore) { }

  ngOnInit(): void {
    this.page = 1;
    this.pageAttr = 1;
    this.tableSize = 10;
    this.showFrom = 0;
    this.showTo = 0;
    this.paginationCount = 0;
    this.isNoneSelected = true;
    this.isViewOpen = false;
    this.selectedButton = this.checkReviewStatus ? this.selectedPartnerName : OemConstants.SELECT_PARTNER;
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.noData = false;
    if (this.checkReviewStatus) {
      this.selectedButton = this.selectedPartnerName === undefined ? OemConstants.SELECT_PARTNER : this.selectedPartnerName;
      this.contents = this.contentsInfo.contents;
      this.pID = this.contentsInfo.partnerID[0];
      this.paginationCount = this.contentsInfo.paginationContext.totalItems;
      this.showFrom = ((this.page - 1) * this.tableSize) + 1;
      this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
      if (this.contents.length === 0) {
        this.showFrom = 0;
        this.showTo = 0;
      }
    }
    this.getAllPartnerData();
    this.store.partnerData
      .subscribe(res => {
        if (res.length) {
          this.selectedPartner(res[0], res[1]);
          this.isPartnerTabActive = res[2];
        }
      })
  }

  getAllAttractLoop(type, sortType) {
    this.oemService.getAllAttracatLoopByPid(this.pID, type, sortType)
      .subscribe(res => {
        this.displayAttr = res.attractLoops.map(item => {
          if (item.locations) {
            try {
              item.parsedLocations = JSON.parse(item.locations);
            } catch (error) {
              console.error('Error parsing locations:', error);
              item.parsedLocations = [];
            }
          }
          return item;
        });
        
        this.AttrPageCount = this.displayAttr.length;
        this.attShowFrom = ((this.pageAttr - 1) * this.tableSize) + 1;
        this.attrShowTo = Math.min(this.pageAttr * this.tableSize, this.AttrPageCount);
      });
  }

  selectedPartner(data, pID) {
    this.partnerLabel = data;
    this.pID = pID;
    this.selectedButton = data;
    this.page = 1;
    this.getContentData(pID, OemConstants.SUBMITTED_STATUS);
    this.getAllAttractLoop(this.type, this.sortType);
  }

  openView(data, contentID?, autoID?) {
    if (this.isPartnerTabActive) {
      this.store.setPartnerData([]);
      this.partner = data;
      this.isReviewOpen = true;
      this.reviewOn.emit(true);
      this.sendPartner.emit(data);
      this.contentID.emit(contentID);
      this.autoID.emit(autoID);
      this.store.setPartnerData([this.partnerLabel, this.pID, true]);
    } else {
      this.attrID.emit(data);
      this.attrViewOpen.emit(true);
      this.adminRef.emit(true);
      this.pid.emit(this.pID);
      this.enableComments.emit(true);
      this.store.setPartnerData([this.partnerLabel, this.pID, false]);
    }
  }

  getContentData(pID, status) {
    this.oemService.getContentDataUsingPartnerID(this.globalSortBy, this.globalSortValue, this.page, pID, status)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getApprovedPartnerResponse => {
        this.contents = getApprovedPartnerResponse.contents as Content[];
        this.paginationCount = (getApprovedPartnerResponse.paginationContext.totalItems);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.contents.length === 0) {
          this.isPartnerTabActive = false;
          this.showFrom = 0;
          this.showTo = 0;
          this.noData = true;
        } else {
          this.isPartnerTabActive = true;
          this.noData = false;
        }
      });
  }

  getAllPartnerData() {
    this.partnersService.getApprovedPartners(OemConstants.SUBMITTED_STATUS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllPartnerResponse => {
        this.partner = getAllPartnerResponse.partnerName;
        this.partnerID = getAllPartnerResponse.partnerID;
        this.isPartnerEmpty = (this.partner.length == 0) || false;
        let temp = new Map()
        this.partner.forEach((e, i) => {
          temp.set(e, this.partnerID[i])
        })
        this.partnerData = new Map([...temp.entries()].sort());
        this.partner = Array.from(this.partnerData.keys());
        this.partnerID = Array.from(this.partnerData.values());
      });
  }

  onTableDataChange(event) {
    if (this.isPartnerTabActive) {
      this.page = event;
      this.getContentData(this.pID, OemConstants.SUBMITTED_STATUS);
    } else {
      this.attShowFrom = ((event - 1) * this.tableSize) + 1;
      this.attrShowTo = Math.min(event * this.tableSize, this.AttrPageCount);
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    if (this.isPartnerTabActive) {
      this.globalSortValue = this.globalSortValue !== OemConstants.ASCENDING_ORDER ? OemConstants.ASCENDING_ORDER :
        OemConstants.DESCENDING_ORDER;
      this.globalSortBy = tempval;
      this.getContentData(this.pID, OemConstants.SUBMITTED_STATUS);
    } else {
      if (this.type !== tempval) {
        this.sortType = OemConstants.ASCENDING_ORDER;
        this.type = tempval
      } else {
        this.sortType = this.sortType === OemConstants.ASCENDING_ORDER ? OemConstants.DESCENDING_ORDER : OemConstants.ASCENDING_ORDER;
      }
      this.getAllAttractLoop(tempval, this.sortType);
    }
  }

  sort(sortKey: string) {
    if (this.isPartnerTabActive) {
      switch (sortKey) {
        case ('contentName'):
          this.sortingTableWithAscandDesc('contentName');
          break;
        case ('languageCategory'):
          this.sortingTableWithAscandDesc('languageCategory');
          break;
        case ('systemID'):
          this.sortingTableWithAscandDesc('systemID');
          break;
        case ('editedByName'):
          this.sortingTableWithAscandDesc('editedByName');
          break;
        case ('updatedTime'):
          this.sortingTableWithAscandDesc('updatedTime');
          break;
        default: {
        }
      }
    } else {
      this.sortingTableWithAscandDesc(sortKey);
    }
  }
  // attract loop 
  tabChange() {
    this.isPartnerTabActive = !this.isPartnerTabActive;
  }
}
